/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
/* NEW TAB fols to accordian on mobile */
(function () {
    'use strict';

    const toggleClass = function (otherElems, thisElem, className = 'is-active') {
        for (const otherElem of otherElems) {
            otherElem.classList.remove(className);
        }
        thisElem.classList.add(className);
    };

    const gotoTab = function (currId) {
    const element = document.getElementById(currId);
    if (element) {
        const offset = 120; // Margin from the top
        const elementPosition = element.getBoundingClientRect().top + window.scrollY;
        const offsetPosition = elementPosition - offset;

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth' // Smooth scrolling effect
        });
    }
};


    const toggleVerticalTabs = function (tabContainer, tabs, items, item) {
        item.onclick = function (e) {

                    // Ignore clicks inside tab content
                if (e.target.closest('.ootb-tabcordion--entry-content')) return;

                // Ignore Ask Question button clicks
                if (e.target.closest('.simpAskQuestionForm-btnOpen')) return;

            const currId = item.getAttribute('id');
            const tab = tabContainer.querySelector('.ootb-tabcordion--tabs [aria-controls="' + currId + '"]');

            if (hasTabs(tabContainer)) {
                toggleClass(tabs, tab);
                toggleClass(items, item);
            } else {
                item.classList.toggle('is-active');
                tab.classList.toggle('is-active', item.classList.contains('is-active'));
            }

            gotoTab(currId);
        };
    };

    const toggleTabs = function (tabContainer) {
        const tabs = tabContainer.querySelectorAll('.ootb-tabcordion--tabs .tab');
        const items = tabContainer.querySelectorAll('.ootb-tabcordion--entry');

        for (const tab of tabs) {
            tab.onclick = function () {
                const target = tab.getAttribute('aria-controls');
                const content = document.getElementById(target);

                if (hasTabs(tabContainer)) {
                    // In tab mode, only one tab open
                    toggleClass(tabs, tab);
                    toggleClass(items, content);
                } else {
                    // In accordion mode, toggle independently
                    content.classList.toggle('is-active');
                    tab.classList.toggle('is-active', content.classList.contains('is-active'));
                }
            };
        }

        for (const item of items) {
            toggleVerticalTabs(tabContainer, tabs, items, item);
        }
    };

    const hasTabs = function (container) {
        return container.classList.contains('has-tabs');
    };

    const modeSwitcher = function (tabContainer, containerWidth) {
        const tabs = tabContainer.querySelectorAll('.tab');
        const container = tabContainer.closest('.ootb-tabcordion');
        let totalW = 0;

        for (const tab of tabs) {
            totalW += tab.offsetWidth;
        }

        if (totalW >= containerWidth) {
            container.classList.remove('has-tabs'); // Accordion mode
        } else {
            container.classList.add('has-tabs'); // Tab mode
        }
    };

    // Ensure mode switches dynamically on screen resize
    const resizeObserver = new ResizeObserver(entries => {
        for (let entry of entries) {
            modeSwitcher(entry.target, entry.contentRect.width);
        }
    });

    document.addEventListener("DOMContentLoaded", function () {
        const tabContainers = document.querySelectorAll('.ootb-tabcordion');

        for (const tabContainer of tabContainers) {
            const tabList = tabContainer.querySelector('.ootb-tabcordion--tabs');
            if (tabList) {
                resizeObserver.observe(tabList);
            }
            modeSwitcher(tabContainer, tabList.clientWidth); // Check mode on page load
            toggleTabs(tabContainer);
        }
    });

})();




//additional link from outside Tab - nathan
  
function showTab(tabNum) {
  const tabId = `tab${tabNum}`;
  const tabButtonId = `${tabId}-tab`;

  const allTabs = document.querySelectorAll(".ootb-tabcordion--tabs .tab");
  const allEntries = document.querySelectorAll(".ootb-tabcordion--entry");

  // Clear actives
  allTabs.forEach(tab => tab.classList.remove("is-active"));
  allEntries.forEach(entry => entry.classList.remove("is-active"));

  const selectedTab = document.getElementById(tabButtonId);
  const selectedEntry = document.getElementById(tabId);

  if (selectedTab && selectedEntry) {
    selectedTab.classList.add("is-active");
    selectedEntry.classList.add("is-active");

    const tabContainer = selectedEntry.closest(".ootb-tabcordion");

    if (tabContainer && !tabContainer.classList.contains("has-tabs")) {
      // Mobile accordion mode
      // Wait until the browser paints the expanded content, then scroll
      requestAnimationFrame(() => {
        setTimeout(() => {
          selectedEntry.scrollIntoView({ behavior: "smooth", block: "start" });
          history.replaceState(null, null, `#${tabId}`);
        }, 250); // match your accordion transition speed
      });
    } else {
      // Desktop tab mode
      location.hash = tabId;
    }
  } else {
    console.warn(`Tab ${tabNum} not found`);
  }
}

//internal link to tab

document.addEventListener('click', function (e) {
  const trigger = e.target.closest('[data-open-tab]');
  if (!trigger) return;

  e.preventDefault();
  e.stopPropagation(); // THIS is the missing piece

  const tabNum = trigger.getAttribute('data-open-tab');
  showTab(tabNum);
});

// Handle Ask Question button inside accordion
document.addEventListener("click", function (e) {

  const askBtn = e.target.closest(".simpAskQuestionForm-btnOpen");
  if (!askBtn) return;

  e.preventDefault();
  e.stopPropagation(); // stop accordion toggle

  const form = document.getElementById("simpAskForm_container");

  if (form) {
    form.style.display = "block";
  }

});

// open first menu item on mobile

document.querySelector('[aria-controls="mobile-panel-0"]').addEventListener('click', () => {
var mobileFirstItem = document.querySelector('[aria-controls="mobile-list-0"]');
mobileFirstItem.click()
})

// close cart ob continue shopping button
function closeMiniCart() {
  event.preventDefault(); // Prevent form to be submitted
  var miniCartdisplay = document.getElementById("mini-cart");
  miniCartdisplay.setAttribute('aria-hidden', 'true');
}

/**
 * A lightweight youtube embed. Still should feel the same to the user, just MUCH faster to initialize and paint.
 *
 * Thx to these as the inspiration
 *   https://storage.googleapis.com/amp-vs-non-amp/youtube-lazy.html
 *   https://autoplay-youtube-player.glitch.me/
 *
 * Once built it, I also found these:
 *   https://github.com/ampproject/amphtml/blob/master/extensions/amp-youtube (👍👍)
 *   https://github.com/Daugilas/lazyYT
 *   https://github.com/vb/lazyframe
 */
class LiteYTEmbed extends HTMLElement {
    connectedCallback() {
        this.videoId = this.getAttribute('videoid');

        let playBtnEl = this.querySelector('.lty-playbtn');
        // A label for the button takes priority over a [playlabel] attribute on the custom-element
        this.playLabel = (playBtnEl && playBtnEl.textContent.trim()) || this.getAttribute('playlabel') || 'Play';

        /**
         * Lo, the youtube placeholder image!  (aka the thumbnail, poster image, etc)
         *
         * See https://github.com/paulirish/lite-youtube-embed/blob/master/youtube-thumbnail-urls.md
         *
         * TODO: Do the sddefault->hqdefault fallback
         *       - When doing this, apply referrerpolicy (https://github.com/ampproject/amphtml/pull/3940)
         * TODO: Consider using webp if supported, falling back to jpg
         */
        if (!this.style.backgroundImage) {
          this.style.backgroundImage = `url("https://i.ytimg.com/vi/${this.videoId}/hqdefault.jpg")`;
        }

        // Set up play button, and its visually hidden label
        if (!playBtnEl) {
            playBtnEl = document.createElement('button');
            playBtnEl.type = 'button';
            playBtnEl.classList.add('lty-playbtn');
            this.append(playBtnEl);
        }
        if (!playBtnEl.textContent) {
            const playBtnLabelEl = document.createElement('span');
            playBtnLabelEl.className = 'lyt-visually-hidden';
            playBtnLabelEl.textContent = this.playLabel;
            playBtnEl.append(playBtnLabelEl);
        }
        playBtnEl.removeAttribute('href');

        // On hover (or tap), warm up the TCP connections we're (likely) about to use.
        this.addEventListener('pointerover', LiteYTEmbed.warmConnections, {once: true});

        // Once the user clicks, add the real iframe and drop our play button
        // TODO: In the future we could be like amp-youtube and silently swap in the iframe during idle time
        //   We'd want to only do this for in-viewport or near-viewport ones: https://github.com/ampproject/amphtml/pull/5003
        this.addEventListener('click', this.addIframe);

        // Chrome & Edge desktop have no problem with the basic YouTube Embed with ?autoplay=1
        // However Safari desktop and most/all mobile browsers do not successfully track the user gesture of clicking through the creation/loading of the iframe,
        // so they don't autoplay automatically. Instead we must load an additional 2 sequential JS files (1KB + 165KB) (un-br) for the YT Player API
        // TODO: Try loading the the YT API in parallel with our iframe and then attaching/playing it. #82
        this.needsYTApiForAutoplay = navigator.vendor.includes('Apple') || navigator.userAgent.includes('Mobi');
    }

    /**
     * Add a <link rel={preload | preconnect} ...> to the head
     */
    static addPrefetch(kind, url, as) {
        const linkEl = document.createElement('link');
        linkEl.rel = kind;
        linkEl.href = url;
        if (as) {
            linkEl.as = as;
        }
        document.head.append(linkEl);
    }

    /**
     * Begin pre-connecting to warm up the iframe load
     * Since the embed's network requests load within its iframe,
     *   preload/prefetch'ing them outside the iframe will only cause double-downloads.
     * So, the best we can do is warm up a few connections to origins that are in the critical path.
     *
     * Maybe `<link rel=preload as=document>` would work, but it's unsupported: http://crbug.com/593267
     * But TBH, I don't think it'll happen soon with Site Isolation and split caches adding serious complexity.
     */
    static warmConnections() {
        if (LiteYTEmbed.preconnected) return;

        // The iframe document and most of its subresources come right off youtube.com
        LiteYTEmbed.addPrefetch('preconnect', 'https://www.youtube-nocookie.com');
        // The botguard script is fetched off from google.com
        LiteYTEmbed.addPrefetch('preconnect', 'https://www.google.com');

        // Not certain if these ad related domains are in the critical path. Could verify with domain-specific throttling.
        LiteYTEmbed.addPrefetch('preconnect', 'https://googleads.g.doubleclick.net');
        LiteYTEmbed.addPrefetch('preconnect', 'https://static.doubleclick.net');

        LiteYTEmbed.preconnected = true;
    }

    fetchYTPlayerApi() {
        if (window.YT || (window.YT && window.YT.Player)) return;

        this.ytApiPromise = new Promise((res, rej) => {
            var el = document.createElement('script');
            el.src = 'https://www.youtube.com/iframe_api';
            el.async = true;
            el.onload = _ => {
                YT.ready(res);
            };
            el.onerror = rej;
            this.append(el);
        });
    }

    async addYTPlayerIframe(params) {
        this.fetchYTPlayerApi();
        await this.ytApiPromise;

        const videoPlaceholderEl = document.createElement('div')
        this.append(videoPlaceholderEl);

        const paramsObj = Object.fromEntries(params.entries());

        new YT.Player(videoPlaceholderEl, {
            width: '100%',
            videoId: this.videoId,
            playerVars: paramsObj,
            events: {
                'onReady': event => {
                    event.target.playVideo();
                }
            }
        });
    }

    async addIframe(){
        if (this.classList.contains('lyt-activated')) return;
        this.classList.add('lyt-activated');

        const params = new URLSearchParams(this.getAttribute('params') || []);
        params.append('autoplay', '1');
        params.append('playsinline', '1');

        if (this.needsYTApiForAutoplay) {
            return this.addYTPlayerIframe(params);
        }

        const iframeEl = document.createElement('iframe');
        iframeEl.width = 560;
        iframeEl.height = 315;
        // No encoding necessary as [title] is safe. https://cheatsheetseries.owasp.org/cheatsheets/Cross_Site_Scripting_Prevention_Cheat_Sheet.html#:~:text=Safe%20HTML%20Attributes%20include
        iframeEl.title = this.playLabel;
        iframeEl.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
        iframeEl.allowFullscreen = true;
        // AFAIK, the encoding here isn't necessary for XSS, but we'll do it only because this is a URL
        // https://stackoverflow.com/q/64959723/89484
        iframeEl.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(this.videoId)}?${params.toString()}`;
        this.append(iframeEl);

        // Set focus for a11y
        iframeEl.focus();
    }
}
// Register custom element
customElements.define('lite-youtube', LiteYTEmbed);

/**
 * GA4 - Product Recommendations view_item_list
 * Fires when Shopify's native recommendations AJAX call completes
 * Hooks into the Warehouse theme's ProductRecommendations section
 * Data extracted from rendered product card DOM elements
 */
document.addEventListener('DOMContentLoaded', function() {
  const recommendationsSection = document.querySelector('[data-section-type="product-recommendations"]');
  
  if (!recommendationsSection) return;

  const recommendationsContainer = recommendationsSection.querySelector('.product-recommendations');
  
  if (!recommendationsContainer) return;

  // Observe the recommendations container for AJAX content replacement
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length > 0) {
        const products = [];
        
        recommendationsContainer.querySelectorAll('.product-item').forEach(function(item, index) {
          // Extract product data from DOM elements
          const titleEl = item.querySelector('.product-item__title');
          const skuEl = item.querySelector('.collection-sku');
          const priceEl = item.querySelector('.price');
          const idEl = item.querySelector('input[name="product-id"]');

          // Clean price — remove currency symbol and commas
          const rawPrice = priceEl ? priceEl.textContent.replace(/[^0-9.]/g, '') : '0';

          products.push({
            item_id: skuEl ? skuEl.textContent.trim() : '',
            item_name: titleEl ? titleEl.textContent.trim() : '',
            price: parseFloat(rawPrice) || 0,
            index: index + 1,
            item_list_id: 'product_recommendations',
            item_list_name: 'Product Recommendations'
          });
        });

        if (products.length > 0) {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ ecommerce: null });
          window.dataLayer.push({
            event: 'view_item_list',
            ecommerce: {
              item_list_id: 'product_recommendations',
              item_list_name: 'Product Recommendations',
              items: products
            }
          });

          // Clear ecommerce data to prevent dataLayer pollution on subsequent events
          window.dataLayer.push({ ecommerce: null });

          // Disconnect after firing to avoid duplicate events
          observer.disconnect();
        }
      }
    });
  });

  observer.observe(recommendationsContainer, {
    childList: true,
    subtree: true
  });
});

/**
 * GA4 - Recently Viewed Products view_item_list
 * Fires when Warehouse theme's RecentlyViewedProducts AJAX call completes
 * Uses MutationObserver to detect when products have loaded
 */
document.addEventListener('DOMContentLoaded', function() {
  const recentlyViewedSection = document.querySelector('[data-section-type="recently-viewed-products"]');

  if (!recentlyViewedSection) return;

  const placeholder = recentlyViewedSection.querySelector('.recently-viewed-products-placeholder');

  if (!placeholder) return;

  const sectionTitle = recentlyViewedSection.querySelector('.section__title');
  const listName = sectionTitle ? sectionTitle.textContent.trim() : 'Recently Viewed';

  // Flag to prevent duplicate firing
  let hasFired = false;

  const observer = new MutationObserver(function(mutations) {
    if (hasFired) return;

    const products = [];

    placeholder.querySelectorAll('.product-item').forEach(function(item, index) {
      const titleEl = item.querySelector('.product-item__title');
      const skuEl = item.querySelector('.collection-sku');
      const priceEl = item.querySelector('.price');
      const rawPrice = priceEl ? priceEl.textContent.replace(/[^0-9.]/g, '') : '0';

      products.push({
        item_id: skuEl ? skuEl.textContent.trim() : '',
        item_name: titleEl ? titleEl.textContent.trim() : '',
        price: parseFloat(rawPrice) || 0,
        index: index + 1,
        item_list_id: 'recently_viewed',
        item_list_name: listName
      });
    });

    if (products.length > 0) {
      hasFired = true;
      observer.disconnect();

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: 'view_item_list',
        ecommerce: {
          item_list_id: 'recently_viewed',
          item_list_name: listName,
          items: products
        }
      });

      // Clear ecommerce data after pushing to prevent pollution
      window.dataLayer.push({ ecommerce: null });
    }
  });

  observer.observe(placeholder, {
    childList: true,
    subtree: true
  });
});


/**
 * GA4 - Slideshow select_promotion
 * Fires when a user clicks a slideshow CTA button or slide link
 */
document.addEventListener('DOMContentLoaded', function() {
  const slideshow = document.querySelector('[data-section-type="slideshow"]');

  if (!slideshow) return;

  slideshow.addEventListener('click', function(e) {
    const link = e.target.closest('a');
    
    if (!link) return;

    // Get the parent slide
    const slide = link.closest('[data-slide-index]');

    if (!slide) return;

    const slideIndex = slide.getAttribute('data-slide-index');
    const promotionName = slide.getAttribute('data-promotion-name');
    const promotionId = slide.getAttribute('data-promotion-id');

    if (!promotionName) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: 'select_promotion',
      ecommerce: {
        items: [{
          promotion_id: promotionId,
          promotion_name: promotionName,
          creative_slot: slideIndex,
          location_id: 'homepage_hero'
        }]
      }
    });
  });
});


/**
 * GA4 - Add to Cart from List tracking
 * Primary method: fetch intercept on /cart/add.js
 * Captures item_list_name from product card data attributes
 * Uses sessionStorage to persist list context across interactions
 * Does not interfere with theme cart functionality or G&Y app tracking
 */
(function() {
  if (window.__ga4_atc_loaded) return;
  window.__ga4_atc_loaded = true;

  var STORAGE_KEY = '__ga4_list_ctx';
  var LIST_TTL_MS = 30 * 60 * 1000; // 30 minutes

  // ---------- Read/write list context from sessionStorage ----------
  function readCtxMap() {
    try { return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}'); }
    catch (e) { return {}; }
  }

  function writeCtxMap(map) {
    try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(map)); }
    catch (e) {}
  }

  // ---------- Capture list context on pointerdown ----------
  document.addEventListener('pointerdown', function(e) {
    // Check for product-item card with data attributes
    var card = e.target.closest('[data-item-list-name]');
    if (!card) return;

    var listName = card.getAttribute('data-item-list-name');
    var listId = card.getAttribute('data-item-list-id') || '';
    var productId = card.getAttribute('data-product-id') || '';

    if (!listName) return;

    var map = readCtxMap();
    var now = Date.now();

    // Store by product ID for accurate matching
    if (productId) {
      map['p_' + productId] = { listName: listName, listId: listId, ts: now };
    }

    // Also store as last clicked as fallback
    map['__last'] = { listName: listName, listId: listId, ts: now };

    writeCtxMap(map);
  }, true);

  // ---------- Get list context for a given product ----------
  function getCtxFor(productId) {
    var map = readCtxMap();
    var now = Date.now();
    var ctx = (productId && map['p_' + productId]) || map['__last'];
    if (!ctx || (now - ctx.ts) > LIST_TTL_MS) return null;
    return ctx;
  }

  // ---------- Push add_to_cart_from_list to dataLayer ----------
  function pushEvent(lines) {
    if (!lines || !lines.length) return;

    var value = lines.reduce(function(sum, item) {
      return sum + (item.price * item.quantity);
    }, 0);

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: 'add_to_cart_from_list',
      ecommerce: {
        currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'GBP',
        value: Math.round(value * 100) / 100,
        items: lines
      }
    });
    window.dataLayer.push({ ecommerce: null });
  }

  // ---------- De-duplication ----------
  var firedRecently = {};
  function dedupeKey(lines) {
    return lines.map(function(i) {
      return i.item_id + 'x' + i.quantity;
    }).join(',');
  }
  function alreadyFired(key) {
    var ts = firedRecently[key];
    return ts && (Date.now() - ts) < 2000;
  }
  function markFired(key) {
    firedRecently[key] = Date.now();
    setTimeout(function() { delete firedRecently[key]; }, 2000);
  }

  // ---------- Build GA4 items array from Shopify response ----------
  function buildItems(added) {
    return added.filter(Boolean).map(function(line) {
      var ctx = getCtxFor(String(line.product_id));
      if (!ctx) return null;
      return {
        item_id: line.sku || String(line.variant_id),
        item_name: line.product_title || line.title,
        item_brand: line.vendor || '',
        item_category: line.product_type || '',
        price: Math.round((line.final_price || line.price) / 100 * 100) / 100,
        quantity: line.quantity || 1,
        item_list_name: ctx.listName,
        item_list_id: ctx.listId
      };
    }).filter(Boolean);
  }

  // ---------- Fetch intercept ----------
  var origFetch = window.fetch;
  window.fetch = function(input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var promise = origFetch.apply(this, arguments);

    if (!/\/cart\/add(\.js|\.json)?(\?|$)/.test(url)) return promise;

    return promise.then(function(response) {
      if (!response || !response.ok) return response;

      response.clone().json().then(function(data) {
        var added = data.items ? data.items : [data];
        var items = buildItems(added);
        if (!items.length) return;

        var key = dedupeKey(items);
        if (alreadyFired(key)) return;
        markFired(key);
        pushEvent(items);
      }).catch(function() {});

      return response;
    });
  };

  // ---------- XHR intercept (fallback) ----------
  var XHR = window.XMLHttpRequest.prototype;
  var origOpen = XHR.open;
  var origSend = XHR.send;

  XHR.open = function(method, url) {
    this.__ga4_url = url;
    return origOpen.apply(this, arguments);
  };

  XHR.send = function() {
    var xhr = this;
    if (/\/cart\/add(\.js|\.json)?(\?|$)/.test(xhr.__ga4_url || '')) {
      xhr.addEventListener('load', function() {
        if (xhr.status < 200 || xhr.status >= 300) return;
        try {
          var data = JSON.parse(xhr.responseText);
          var added = data.items ? data.items : [data];
          var items = buildItems(added);
          if (!items.length) return;

          var key = dedupeKey(items);
          if (alreadyFired(key)) return;
          markFired(key);
          pushEvent(items);
        } catch(e) {}
      });
    }
    return origSend.apply(this, arguments);
  };

})();



// ---------- Fix search on mobile for clerk ----------
(function () {
  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-action="toggle-search"]');
    if (toggle) {
      event.preventDefault();
      event.stopPropagation();

      var wrapper = document.querySelector('.header__search-bar-wrapper');
      var header = wrapper && wrapper.closest('.header');
      var input = wrapper && wrapper.querySelector('.search-bar__input');

      if (wrapper) wrapper.classList.add('is-visible');
      if (header) header.classList.add('header--search-expanded');

      setTimeout(function () {
        if (input) {
          input.focus();
          input.click();
        }
      }, 100);
      return;
    }

    var closeBtn = event.target.closest('[data-action="unfix-search"]');
    if (closeBtn) {
      var wrapper = document.querySelector('.header__search-bar-wrapper');
      var header = wrapper && wrapper.closest('.header');

      if (wrapper) wrapper.classList.remove('is-visible');
      if (header) header.classList.remove('header--search-expanded');
    }
  }, true);
})();


// ---------- Dynamic placeholder text for search ----------
class TypingPlaceholder {
  constructor(input, words, opts = {}) {
    this.input = input;
    this.words = words;
    this.typeSpeed = opts.typeSpeed ?? 40;
    this.deleteSpeed = opts.deleteSpeed ?? 10;
    this.pause = opts.pause ?? 1500;
    this.wordIndex = 0;
    this.charIndex = 0;
    this.deleting = false;
    this.timeoutId = null;
    this.paused = false;

    this.input.addEventListener('focus', () => this.handleFocus());
    this.input.addEventListener('blur', () => this.handleBlur());

    this.tick();
  }

  handleFocus() {
    this.paused = true;
    clearTimeout(this.timeoutId);
    this.input.placeholder = '';
  }

  handleBlur() {
    if (this.input.value) return;
    this.paused = false;
    this.tick();
  }

  tick() {
    if (this.paused) return;

    const word = this.words[this.wordIndex];

    if (this.deleting) {
      this.charIndex--;
    } else {
      this.charIndex++;
    }

    this.input.placeholder = word.slice(0, this.charIndex);

    let delay = this.deleting ? this.deleteSpeed : this.typeSpeed;

    if (!this.deleting && this.charIndex === word.length) {
      delay = this.pause;
      this.deleting = true;
    } else if (this.deleting && this.charIndex === 0) {
      this.deleting = false;
      this.wordIndex = (this.wordIndex + 1) % this.words.length;
      delay = 300;
    }

    this.timeoutId = setTimeout(() => this.tick(), delay);
  }
}

new TypingPlaceholder(document.getElementById('search-input'), [
  'Search for products...',
  'Search "4x4 Winches"...',
  'Search "Hydraulic Winches"...',
  'Search "Synthetic Rope"...',
]);


// ---------- Clerk: hide slider nav buttons if too few products ----------
function updateClerkSliderNav() {
  document.querySelectorAll('.clerk-slider').forEach(function(slider) {
    var items = slider.querySelectorAll('.clerk-slider-item');
    var navPrev = slider.querySelector('.clerk-slider-nav-prev');
    var navNext = slider.querySelector('.clerk-slider-nav-next');

    if (!navPrev || !navNext || items.length === 0) return;

    var totalWidth = 0;
    items.forEach(function(item) {
      totalWidth += item.offsetWidth;
    });

    var wrapperWidth = slider.closest('.clerk-slider-wrapper').offsetWidth;
    var needsNav = totalWidth > wrapperWidth;

    navPrev.style.display = needsNav ? 'block' : 'none';
    navNext.style.display = needsNav ? 'block' : 'none';
  });
}

function pollClerkReady(attempts) {
  attempts = attempts || 0;
  if (attempts > 20) return;
  var navExists = document.querySelector('.clerk-slider-nav');
  var itemsExist = document.querySelector('.clerk-slider-item');
  if (navExists && itemsExist) {
    updateClerkSliderNav();
  } else {
    setTimeout(function() { pollClerkReady(attempts + 1); }, 100);
  }
}

var clerkDebounce;
var observer = new MutationObserver(function() {
  clearTimeout(clerkDebounce);
  clerkDebounce = setTimeout(updateClerkSliderNav, 150);
});

document.addEventListener('DOMContentLoaded', function() {
  pollClerkReady();
  window.addEventListener('resize', updateClerkSliderNav);

  // Watch for any Clerk re-renders anywhere in the document
  observer.observe(document.body, { childList: true, subtree: true });
});

// ---------- push cart out so we can layer above Clerk search ----------
(function () {
  function detachMiniCart() {
    var headerEl = document.querySelector('[data-section-type="header"] .header');
    var miniCart = headerEl && headerEl.querySelector('.mini-cart');

    if (!headerEl || !miniCart || miniCart.dataset.detached === 'true') return;

    var ancestor = miniCart.parentElement;
    while (ancestor && ancestor !== document.body) {
      patchContains(ancestor);
      ancestor = ancestor.parentElement;
    }

    function patchContains(el) {
      var original = el.contains.bind(el);
      el.contains = function (node) {
        return original(node) || miniCart.contains(node);
      };
    }

    document.body.appendChild(miniCart);
    miniCart.classList.add('mini-cart--detached');
    miniCart.dataset.detached = 'true';

    function positionMiniCart() {
      var headerRect = headerEl.getBoundingClientRect();
      miniCart.style.setProperty('top', headerRect.bottom + 'px', 'important');
      miniCart.style.setProperty('right', '0px');
      miniCart.style.setProperty('left', 'auto');
    }

    positionMiniCart();
    window.addEventListener('resize', positionMiniCart);

    var observer = new MutationObserver(function () {
      if (miniCart.getAttribute('aria-hidden') === 'false') {
        positionMiniCart();

        setTimeout(function () {
          // Re-run the Clerk config script so cart_product_accessories global is updated
          miniCart.querySelectorAll('script').forEach(function (s) {
            if (s.textContent.includes('cart_product_accessories')) {
              try {
                new Function(s.textContent)();
              } catch (e) {}
            }
          });

          // Now render Clerk with the updated globals
          var clerkEl = document.querySelector('.clerk[data-template="@mini-cart-cross-sells"]');
          if (clerkEl && window.Clerk && !clerkEl.querySelector('.clerk-mini-cart')) {
            Clerk('content', '.clerk');
          }
        }, 400);
      }
    });
    observer.observe(miniCart, { attributes: true, attributeFilter: ['aria-hidden'] });
  }

  window.addEventListener('load', detachMiniCart);

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector('[data-section-type="header"]')) {
      detachMiniCart();
    }
  });

})();



// ---------- Minicart: remove injected inline styles to help make slider ----------
document.addEventListener('DOMContentLoaded', function () {
  const miniCart = document.getElementById('mini-cart');
  if (!miniCart) return;

  new MutationObserver(function () {
    miniCart.style.removeProperty('top');
    miniCart.style.removeProperty('left');
    miniCart.style.removeProperty('right');
    miniCart.style.removeProperty('max-height');

    const content = miniCart.querySelector('.mini-cart__content');
    if (content) content.style.removeProperty('max-height');
  }).observe(miniCart, {
    attributes: true,
    attributeFilter: ['style']
  });
});


// ---------- Minicart: close button ----------
document.addEventListener('click', function (e) {
  if (e.target.closest('.mini-cart__close')) {
    const toggleBtn = document.querySelector('[data-action="toggle-mini-cart"]');
    if (toggleBtn) toggleBtn.click();
  }
});



// ---------- Clerk accessories in mini-cart: preserve render across section refreshes ----------
// Clerk - run clerk after each cart event to ensure recommendations display
const clerkCartObserver = new MutationObserver(function(mutations) {
  var needsClerk = false;

  for (const mutation of mutations) {
    // Page load / section replace: .clerk element added to DOM
    for (const node of mutation.addedNodes) {
      if (node.nodeType !== 1) continue;
      const clerkEl = node.classList?.contains('clerk') ? node : node.querySelector?.('.clerk');
      if (clerkEl && clerkEl.dataset.template === '@mini-cart-cross-sells') {
        needsClerk = true;
      }
    }
    // Section refresh (morphdom): .clerk-mini-cart wiped from inside .clerk
    for (const node of mutation.removedNodes) {
      if (node.nodeType !== 1) continue;
      if (node.classList?.contains('clerk-mini-cart')) {
        needsClerk = true;
      }
    }
  }

  if (!needsClerk) return;

  clearTimeout(window._clerkRerenderTimer);
  window._clerkRerenderTimer = setTimeout(function() {
    // Re-execute the Liquid-injected Clerk config so globals are current
    var mc = document.getElementById('mini-cart');
    if (mc) {
      mc.querySelectorAll('script').forEach(function(s) {
        if (s.textContent.includes('cart_product_accessories')) {
          try { new Function(s.textContent)(); } catch (e) {}
        }
      });
    }
    // Render if the element is present but empty
    var el = document.querySelector('.clerk[data-template="@mini-cart-cross-sells"]');
    if (el && window.Clerk && !el.querySelector('.clerk-mini-cart')) {
      Clerk('content', '.clerk');
    }
  }, 400);
});
clerkCartObserver.observe(document.body, { childList: true, subtree: true });


/*
// ---------- Clerk accessories in mini-cart: AJAX add to cart for clerk suggestions ----------
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-clerk-add]');
  if (!btn) return;

  e.preventDefault();
  e.stopPropagation();

  var container = btn.closest('.clerk-list-form');
  var variantId = container.querySelector('.clerk-variant-id').value;

  btn.textContent = '...';
  btn.disabled = true;

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
  .then(function (res) {
    if (!res.ok) throw new Error('Failed');
    return res.json();
  })
  .then(function () {
    btn.textContent = '✓ ADDED';

    fetch(window.location.href)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var newCart = tmp.querySelector('#mini-cart');
        var currentCart = document.getElementById('mini-cart');
        if (newCart && currentCart) {
          currentCart.innerHTML = newCart.innerHTML;
        }
      })
      .catch(function () {});
  })
  .catch(function () {
    btn.textContent = '+ ADD';
    btn.disabled = false;
  });
});
*/

// ---------- Clerk: shared AJAX add-to-cart helpers ----------

function clerkRefreshAndOpenCart(btn, successLabel) {
  // Refresh mini-cart HTML
  fetch(window.location.href)
    .then(function (r) { return r.text(); })
    .then(function (html) {
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var newCart = tmp.querySelector('#mini-cart');
      var currentCart = document.getElementById('mini-cart');
      if (newCart && currentCart) {
        currentCart.innerHTML = newCart.innerHTML;
      }
    })
    .catch(function () {})
    .finally(function () {
      // Open Warehouse mini-cart drawer
      document.documentElement.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: { quantity: 1 }
      }));
    });

  if (btn) {
    btn.textContent = successLabel || '✓ ADDED';
  }
}

function clerkAddToCart(variantId, btn, successLabel) {
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  }).then(function (res) {
    if (!res.ok) throw new Error('Failed');
    return res.json();
  });
}

// ---------- Clerk accessories in mini-cart ----------
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-clerk-add]');
  if (!btn) return;

  e.preventDefault();
  e.stopPropagation();

  var container = btn.closest('.clerk-list-form');
  var variantId = container.querySelector('.clerk-variant-id').value;

  btn.textContent = '...';
  btn.disabled = true;

  clerkAddToCart(variantId, btn)
    .then(function () {
      clerkRefreshAndOpenCart(btn, '✓ ADDED');
    })
    .catch(function () {
      btn.textContent = '+ ADD';
      btn.disabled = false;
    });
});

// ---------- Clerk product page recommendations ----------
document.addEventListener('submit', function (e) {
  var form = e.target.closest('form.clerk-product-action');
  if (!form) return;

  e.preventDefault();

  var variantId = form.querySelector('input[name="id"]').value;
  var btn = form.querySelector('button[type="submit"]');

  btn.disabled = true;
  btn.textContent = 'Adding…';

  clerkAddToCart(variantId, btn)
    .then(function () {
      clerkRefreshAndOpenCart(btn, 'Added');
      setTimeout(function () {
        btn.disabled = false;
        btn.textContent = 'Add to cart';
      }, 2500);
    })
    .catch(function () {
      btn.disabled = false;
      btn.textContent = 'Add to cart';
    });
});